import React from 'react';

interface ChartPreviewProps {
  data: unknown;
  config?: Record<string, unknown>;
}

export const ChartPreview: React.FC<ChartPreviewProps> = ({ data, config }) => {
  // Placeholder for chart rendering
  // In a real implementation, this would use a charting library like Chart.js or Recharts
  
  return (
    <div className="w-full h-full min-h-[300px] flex items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300">
      <div className="text-center">
        <svg
          className="w-16 h-16 mx-auto mb-4 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
        <p className="text-gray-500 font-medium">图表预览</p>
        <p className="text-sm text-gray-400 mt-1">
          配置: {JSON.stringify(config || {})}
        </p>
        <pre className="text-xs text-gray-400 mt-2 text-left max-w-md overflow-auto">
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    </div>
  );
};
